/*
 * File: Balances.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates and styles Patient > Balances view
 */
import React, { useState, useEffect } from "react";
import List from "@material-ui/core/List";
import Api from "./Api";
import UIListItem from "components/ui/UIListItem";
import PatientIdStorage from "../../store/PatientIdStore";
import PatientChart from "services/patients/topofthechart/PatientChart";
import MainHeader from "components/MainHeader";
import UIProgress from "components/ui/UIProgress";
import { Toolbar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import FabSpacer from "components/ui/FabSpacer";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    paddingBottom: theme.spacing(0.5),
    marginTop: theme.spacing(2.5)
  }
});

const Balances = ({ classes }) => {
  const [balances, setBalances] = useState([]);
  const [loading, setLoading] = useState(true);
  const patientId = PatientIdStorage.getId();

  useEffect(() => {
    if (!patientId) {
      setLoading(false);
      return;
    }
    const fetchData = async () => {
      const balance = await Api.getBalance(patientId);
      setBalances(balance);
      setLoading(false);
    };
    fetchData();
  }, [patientId]);

  if (loading) return <UIProgress />;

  return (
    <React.Fragment>
      <PatientChart />
      <Toolbar className={classes.toolbar}>
        <MainHeader pageTitle="Balances" pageSubtitle="Patient" />
      </Toolbar>
      <List>
        <UIListItem
          label="Patient"
          value={"$" + balances.patientPortion.toFixed(2)}
        />
        <UIListItem
          label="Insurance"
          value={"$" + balances.insurancePortion.toFixed(2)}
        />
        <UIListItem
          label="Unapplied"
          value={"$" + balances.unapplied.toFixed(2)}
        />
        <UIListItem
          label="Account"
          value={"$" + balances.accountBalance.toFixed(2)}
        />
        <FabSpacer />
      </List>
    </React.Fragment>
  );
};

Balances.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Balances);
